import React from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import useCustomTranslation from "@/hooks/useTranslation";

const TableeHead: React.FC<{
	title: string;
	isMore: boolean;
	onMore: () => void;
}> = ({ title, isMore, onMore }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	return (
		<div className={classes.tableeHeadWrap}>
			<h2>{title}</h2>
			{isMore && (
				<span onClick={() => onMore()}>
					{t("More")}
					{">>"}
				</span>
			)}
		</div>
	);
};

export default TableeHead;

const useStyles = createUseStyles({
	tableeHeadWrap: {
		display: "flex",
		justifyContent: "space-between",
		padding: {
			top: pxToRem(10),
			bottom: pxToRem(10),
		},
		lineHeight: pxToRem(26),
		"& h2": {
			flex: 1,
			color: "#FFFFFF",
			fontSize: pxToRem(16),
			fontWeight: "600",
			overflow: "hidden",
		},
		"& span": {
			color: "#868FA8",
			fontSize: pxToRem(14),
			fontWeight: "400",
			overflow: "hidden",
		},
	},
});
